/**
 * 泰语
 */
const lang = {
	lang: { //语言切换
		langlist: [{
			type: "Chinese",
			name: "ภาษาจีน",
			langimg: "../assets/zg.png"
		},
		{
			type: "English",
			name: "ภาษาอังกฤษ",
			langimg: "../assets/zg.png"
		},
		{
			type: "Traditional",
			name: "ภาษาจีนแบบดั้งเดิม",
			langimg: "../assets/zg.png"
		},
		{
			type: "Japanese",
			name: "ภาษาญี่ปุ่น",
			langimg: "../assets/zg.png"
		},
		{
			type: "Vietnamese",
			name: "ภาษาเวียดนาม",
			langimg: "../assets/zg.png"
		},
		{
			type: "Malay",
			name: "ภาษามลายู",
			langimg: "../assets/zg.png"
		},
		{
			type: "Hindi",
			name: "ชาวอินเดีย",
			langimg: "../assets/zg.png"
		},
		{
			type: "Thai",
			name: "ภาษาไทย",
			langimg: "../assets/zg.png"
		},
		{
			type: "Russian",
			name: "ภาษารัสเซีย",
			langimg: "../assets/zg.png"
		},
		{
			type: "Indonesian",
			name: "ชาวอินโดนิเชีย",
			langimg: "../assets/zg.png"
		}
		],
		langtype: "Hindi",
		langimg: "../assets/zg.png"
	},

	tabbar: { //底部
		index: "หน้าแรก",
		activity: "การเคลื่อนไหว",
		to_promote: "แพร่สนั่น",
		help: "ช่วยเหลือเจือจาน",
		my: "ของฉัน"
	},
	// 提示
	prompt: {
		verification: "รหัสการตรวจสอบข้อผิดพลาด",
		account: "เลขบัญชี 8-20 หรือตัวอักษร",
		password: "รหัสผ่านมากกว่าเท่ากับหกตัวเลขตัวอักษรหรือการรวมกันของตัวอักษร",
		two: "สองรหัสผ่านไม่ตรงกัน",
		successful: "ลงทะเบียนเรียบร้อยแล้ว",
		loginsuccessful: "เข้าสู่ระบบเรียบร้อยแล้ว",
		null: "รหัสผ่านบัญชีไม่สามารถว่างเปล่า",
		Binding: "ผูกพันสำเร็จ",
		address: "กรุณากรอกที่อยู่",
		Please_choose: "กรุณาเลือกหนึ่งและระบุจำนวนเงินเดิมพัน",
		Bet_type: "กรุณาเลือกประเภทของการเดิมพัน",
		success: "เดิมพันที่ประสบความสำเร็จ",
		complete_password: "กรุณาใส่รหัสผ่านเต็ม",
		copy_success: "คัดลอกไปยังแผ่นตัด",
		copy_fail: "คัดลอกล้มเหลว",
		Set_success: "ตั้งค่าเรียบร้อยแล้ว",
		Set_password: "กรุณาตั้งค่ารหัสผ่านตัวเลขหกตัวอักษรไม่ตรงกันและช่องว่าง",
		update_success: "แก้ไขเรียบร้อยแล้ว",
		input_number: "โปรดระบุหมายเลข",
		addressvalue: "กรุณาเลือกที่อยู่กระเป๋า"
	},
	head: { //头部
		luckyhash: "เดิมพันกัญชา",
		address: "ผูกกระเป๋าที่อยู่",
		history: "ประวัติการพนัน",
		help: "ช่วยเหลือเจือจาน",
		lotteryRecord: "ประวัติรางวัล",
		notice: "ประกาศรายชื่อ",
		question: "คำถามที่พบบ่อย",
		performance: "รางวัล",
		add_address: "เพิ่มกระเป๋าสตางค์",
		asset: "รหัสผ่านสินทรัพย์",
		balance: "รายละเอียดยอดคงเหลือ",
		exchangeRecord: "คราว",
		forrecord: "บันทึกการแลกเปลี่ยน",
		language: "การตั้งค่าภาษา",
		update_assets_password: "แก้ไขรหัสผ่านสินทรัพย์",
		update_login_password: "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",

		myteam: "ทีมของฉัน",
		recharge: "ค่าใช้จ่ายสมดุล",
		setting: "ตั้งค่า",
		transactiondetails: "ประวัติการพนัน",
		transfer: "การโอนค่านายหน้า",
		user: "ศูนย์บุคคล",
		userInfo: "รายละเอียดส่วนบุคคล",
		withdrawal: "ถอนเงิน",
		commission: "เงินสดค่านายหน้า",
		withdrawalRecord: "การบันทึก",
		top_up: "บันทึกค่าใช้จ่าย"
	},
	withdrawalRecord: {
		Select_month: "เลือกเดือน",
		afterPrice: "ยอดคงเหลือ",

	},
	withdrawal: {
		withdrawalrecord: "การบันทึก",
		commission: "สินทรัพย์เงินสด",
		number: "จำนวนของการถ่ายโอน",
		withdrawal_number: "ถอนเงิน",
		money_address: "ที่อยู่กระเป๋าสตางค์",
		addressvalue: "กรุณาเลือกที่อยู่กระเป๋าเงินสด",
		poundage: "ค่าธรรมเนียม",
		immediately: "เสนอให้",
		Warm_prompt: "กรุณากรอกที่อยู่กระเป๋าเงินที่ถูกต้องมิฉะนั้นคุณไม่สามารถถอนเงินได้ทันทีที่คุณกรอกที่อยู่กระเป๋าเงินไม่สามารถแก้ไขได้กรุณาติดต่อฝ่ายบริการลูกค",
		input_password: 'กรุณาใส่รหัสผ่านสินทรัพย์',
		betting: "การพนัน",

	},
	userInfo: {
		Head_portrait: "หัวส่วนบุคคล",
		account: "อธิบายแจกแจง",
		Choose_picture: "เลือกหัว",
		cancel: "ยกเลิก",
		determine: "ยืนยัน"
	},
	user: {
		wallet_account: "บัญชีกระเป๋าสตางค์",
		balance: "รายละเอียดยอดคงเหลือ",
		top_up: "เติม",
		withdrawal: "ถอนเงิน",
		my_wallet: "กระเป๋าสตางค์ของฉัน",
		add_wallet: "เพิ่มกระเป๋าสตางค์",
		look: "ดูบันทึก",
		look_all: "ดูเพิ่มเติม",
		Pack_up: "ปิดกั้น",
		For_record: "บันทึกการแลกเปลี่ยน",
		bettingRecord: "รายละเอียดธุรกรรม",
		reward: "รางวัลโปรโมชั่น",
		goCustomerLink: "เว็บบอร์ดออนไลน์",
		Commission_account: "บัญชีค่านายหน้า",
		transfer: "ขยับเขยื้อนเคลื่อนไหว",
		number: "ข้อมูลการพนัน",
		transactiondetails: "ดูรายละเอียด",
		day: "เดิมพันวันนี้",
		day_winning: "ชนะรางวัลวันนี้",
		my_team: "ทีมของฉัน",
		about_we: "เกี่ยวกับเรา",
		center: "เว็บบอร์ด",
		setting: "ตั้งค่า",
	},
	transfer: {
		money: "ดุลค่านายหน้า",
		account_balance: "ดุลบัญชี",
		number: "จำนวนของการถ่ายโอน",
		select: "โปรดเลือก",
		Immediately_transfer: "โอนทันที",
		password: "กรุณาใส่รหัสผ่านสินทรัพย์",
		betting: "การพนัน",

	},
	transactiondetails: {
		type: "รูปร่างลักษณะ",
		input_type: "กรุณาเลือกประเภท",
		date: "เดท",
		select_date: "กรุณาเลือกวันที่",
		select: "สอบถาม",
		bettingmoney: "วางเดิมพัน",
		winning_amount: "ชนะ",
		time: "กาละ",
		not: "ไม่มีข้อมูล",
		B1: 'กัญชาโชคดี-ขนาดโชคดี',
		B2: 'กัญชาโชคดี-กลุ่มโชคดี',
		B3: 'กัญชาโชคดี-เสือมังกรนำโชค',
		B4: 'กัญชาโชคดี-โชคดีว่าง',
		B5: 'กัญชาโชคดี-เลขนำโชค',
		A1: 'กัญชาเมืองบันเทิง-เกมส์รถแข่ง',
		A2: 'กัญชาเมืองบันเทิง-เรือโชคดี',
		A3: 'กัญชาเมืองบันเทิง-การแข่งม้าโชคดี',
		A4: 'กัญชาเมืองบันเทิง-ขนาดโชคดี',
		A5: 'กัญชาเมืองบันเทิง-กลุ่มโชคดี',
		A6: 'กัญชาเมืองบันเทิง-เสือมังกรนำโชค',
		A7: 'กัญชาเมืองบันเทิง-โชคดีว่าง',
		A8: 'กัญชาเมืองบันเทิง-เลขนำโชค',
		options: [{
			value: "กัญชาโชคดี-สองหน้า",
			label: "B1",
		},
		{
			value: "กัญชาโชคดี-กลุ่มก้อน",
			label: "B2",
		},
		{
			value: "กัญชาโชคดี-มังกรและเสือรวมกัน",
			label: "B3",
		},
		{
			value: "กัญชาโชคดี-ทุกครอบครัว",
			label: "B4",
		},
		{
			value: "กัญชาโชคดี-ความกล้าหาญ",
			label: "B5",
		},
		],
	},
	setting: {
		updatepwd: "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
		assets_pwd: "รหัสผ่านสินทรัพย์",
		not: "ไม่ได้ตั้งค่า",
		yes: "ตั้งค่า",
		language: "การตั้งค่าภาษา",
		exit: "ถอนตัว",

	},
	recharge: {
		recharge_code: "บันทึกค่าใช้จ่าย",
		Chain_type: "ประเภทของห่วงโซ่",
		address: "ที่อยู่เต็ม",
		copy_address: "คัดลอกที่อยู่",
		remind: "การแจ้งเตือน",
		content: "เนื้อหาเนื้อหาเนื้อหาเนื้อหา"
	},
	myteam: {
		select: "สอบถาม",
		time: "เดท",
		money: "คณะกรรมการวัน",
		people: "จำนวนผู้ใต้บังคับบัญชาโดยตรง",
		team: "ทีม",
		jryj: 'ผลงานวันนี้',
		jrsy: 'รายได้วันนี้',
		ljsy: 'รายได้สะสม',
		friendsCategoryList: ['เพื่อนชั้นเฟิร์สคลาส', 'เพื่อนรอง', 'เพื่อนระดับสาม', 'เพื่อนชั้นป.4', 'เพื่อนชั้น5'],
	},
	login: {
		order_password: "รหัสผ่านเก่า",
		input_ordpwd: "กรุณาใส่รหัสผ่านเก่า",
		new_pwd: "รหัสผ่านใหม่",
		number: "กรุณาตั้งค่า 6-16 กรณีตัวอักษรและตัวเลข",
		six_pwd: "กรุณาป้อนรหัสผ่านบิต",
		confirmPassword: "ยืนยันรหัสผ่าน",
		confirm: "ยืนยัน",
	},
	forrecord: {
		spending: "ค่าใช้จ่ายในการแลกเปลี่ยน",
	},
	exchangeRecord: {
		exchangeRecord: "คราว",
		record: "อัดแผ่นเสียง",
		For_spending: "ค่าใช้จ่ายในการแลกเปลี่ยน",
		money: "ปริมาณการแลกเปลี่ยน",
		exchange_number: "ปริมาณการแลกเปลี่ยน",
		number: "จำนวนรวม",
		market_price: "ราคาค่างวด",
		Miners_fee: "ค่าธรรมเนียมเหมือง",
		input_money: "กรุณาระบุจำนวนเงินที่แลกเปลี่ยน",
		Get_the_amount: "ได้รับเงิน",
		Can_be: "ได้รับ",
		address: "ที่อยู่กระเป๋าสตางค์",
		Immediatelychange: "เปลี่ยนทันที",
		Warm_prompt: "เคล็ดลับอบอุ่น",
		details: "รายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียดรายละเอียด"
	},
	balance: {
		balance_of: "ยอดคงเหลือ",
		data: "เดท",
		dataPickerRange: "โปรดเลือก",
		select: "สอบถาม",
		to: 'to'
	},
	asset: {
		password: "กรุณาตั้งค่ารหัสผ่านตัวเลขหกตัวอักษรไม่ตรงกันและช่องว่าง",
		confirm: "ยืนยัน",
	},
	add_address: {
		money_address: "กรุณาป้อนที่อยู่กระเป๋าสตางค์",
		save: "เก็บรักษา"
	},
	spread: {
		cumulative: "คุณได้รับเชิญ",
		people: "มนุษย์",
		make: "ได้รับ",
		Continue_to: "พยายามที่จะชนะรางวัล",
		url: "แบ่งปันการเชื่อมโยง",
		Friends_registered: "ลงทะเบียนเพื่อน",
		money: "กระเป๋าสตางค์",
		Friends_deal: "การซื้อขายเพื่อน",
		copy_url: "คัดลอกลิงค์เชิญ",
		my_group: "ทีมของฉัน",
		look: "ดูรายละเอียด",
		directCount: "จำนวนผู้ใต้บังคับบัญชาโดยตรง",
		group: "จำนวนทีม",
		Commission_withdrawal: "เงินสดค่านายหน้า",
		historyAward: "ประวัติคณะกรรมการ",
		yesterdayAward: "คณะกรรมการเมื่อวานนี้",
		currentAward: "คณะกรรมการในปัจจุบัน",
		todayAward: "ผลวันนี้",
		my_invite: "รหัสเชิญของฉัน",
		copy_invite: "คัดลอกรหัสเชิญ",
		top_title: "ผู้บังคับบัญชาของฉัน",
		update: "ไม่สามารถแก้ไขได้หลังจากผูกพันกับผู้บังคับบัญชา",
		nikname: "ป้อนชื่อเล่นของผู้บังคับบัญชาที่คุณต้องการผูก",
		binding: "จำกัด",
		Commission_ratio: "อัตราส่วนค่านายหน้า",
		level: "ระดับตำแหน่ง",
		ratio: "สัดส่วนของการเดิมพัน",
		Directly_under: "ผู้ใต้บังคับบัญชาโดยตรง",
		first: "ข่าว",
		levelone: "ระดับตำแหน่ง",

	},
	performance: {
		datatime: "เดท",
		pick: "โปรดเลือก",
		select: "สอบถาม",
		total: "ผลทั้งหมดของวันนี้",
		performance: "รายละเอียดการปฏิบัติงาน",
		directCount: "จำนวนผู้เล่นโดยตรง",
		todayTotalPerformByDirect: "ประสิทธิภาพของผู้เล่นโดยตรงในวันนี้",
		other: "จำนวนผู้เล่นคนอื่น",
		todayTotalPerformByOther: "การแสดงของผู้เล่นคนอื่น",
		Commission_withdrawal: "เงินสดค่านายหน้า",
		historyAward: "ประวัติคณะกรรมการ",
		yesterdayAward: "คณะกรรมการเมื่อวานนี้",
		currentAward: "คณะกรรมการในปัจจุบัน",
		todayAward: "ผลวันนี้",
		Commission_ratio: "อัตราส่วนค่านายหน้า",
		level: "ระดับตำแหน่ง",
		ratio: "สัดส่วนของการเดิมพัน",
		Directly_under: "ผู้ใต้บังคับบัญชาโดยตรง",
		first: "ข่าว",
		levelone: "ระดับตำแหน่ง",
	},
	lotteryRecord: { //开奖记录
		block: "บล็อค",
		highly: "ความสูงของบล็อก",
		results_of: "ผลลัพธ์",

	},
	help: {
		DAPP: "DAPP ขั้นตอนการเล่น",
		a: "คัดลอก DAPP เกมที่อยู่สำหรับการถ่ายโอน usdt-trc20",
		b: "เปิดเว็บไซต์นี้ในเครือข่าย TRX กระเป๋าสตางค์และเดิมพัน DAPP ทันทีโดยไม่ต้องคัดลอก",
		Focus_on: "กรุณามักจะมุ่งเน้นไปที่การรีเฟรชหน้าแรกของเราและได้รับที่อยู่ธุรกรรมล่าสุด",
		login: "เข้าสู่ระบบเครือข่ายอย่างเป็นทางการสอบถามบล็อกค่า hash",
		hash: "คุณสามารถค้นหาค่า hash ของบล็อกของคุณในเครือข่ายอย่างเป็นทางการของคลื่นฟิลด์",
		you: "คุณอาจจะอยู่ในเครือข่ายอย่างเป็นทางการของคลื่นสนาม",
		login_website: "เข้าสู่ระบบเครือข่ายอย่างเป็นทางการของคลื่นสนาม",
		query: "ค้นหาบล็อกของคุณกัญชาค่า",
		look: "คลิกเพื่อดูการกวดวิชา",
		congratulations: "ยินดีด้วยนะ",
		winning: "ถ้าคุณชนะระบบจะกลับไปที่คุณในหนึ่งนาที",
		address: "ถ้าชนะระบบจะได้รับรางวัลกลับไปที่ที่อยู่การโอนเงินของคุณในหนึ่งนาที",
		number: "ซื้อและแลกเปลี่ยนสกุลเงินดิจิตอล",
		skip: "ข้ามขั้นตอนนี้ถ้ากระเป๋าสตางค์ของคุณมี USDT และ TRX",
		Digital_currency: "ซื้อ USDT และ TRX ในการแลกเปลี่ยนเงินตราดิจิตอลและจากนั้นย้าย USDT และ TRX ใน i91 ของคุณเพื่อกระเป๋าเงินส่วนกลางคุณสามารถใช้กระเป๋าสตางค์ที่ลงทะเบียนในเว็บไซต์กระเป๋าสตางค์ส่วนกลาง",
		platform: "พื้นปฐพี",
		url: "เว็บไซต์",
		tutorial: "กวดวิชา",
		vpn: "ถ้าคุณไม่สามารถเปิดโปรแกรมคุณสามารถใช้ VPN",
		vpnurl: "โคมไฟ VPN เว็บไซต์",
		whirlwind: "ไซโคลนคันเร่งเว็บไซต์",
		can_login: "เข้าสู่ระบบ",
		why: "ทำไมต้องเลือกxxxx",
		most_fair: "ปานกลาง",
		play: "ไม่เตะไม่ตกไม่มีการรบกวน",
		Publicly_available: "บล็อกค่า hash จะถูกสร้างขึ้นแบบสุ่มและผลลัพธ์จะเหมือนกัน",
		security: "ปลอดภัยที่สุด",
		no_money: "กองทุนปฏิบัติการสามารถมองเห็นได้ไม่ต้องกังวลเกี่ยวกับการไม่มีเงินคืนรางวัล",
		Cannot: "บันทึกการโอนเงินของเจ้าของสามารถมองเห็นได้และไม่สามารถเผยแพร่เท็จ",
		Visi_convenient: "สะดวกที่สุด",
		Without_registration: "ไม่ต้องลงทะเบียนไม่ต้องชาร์จไม่ต้องใช้สำหรับการถอนเงิน",
		questions: "คำถามที่พบบ่อย",
		one: "อะไรกัน【บล็อกค่ากัญชา】（Block Hash）",
		dna: "บล็อกค่า hash เป็นส่วนหนึ่งของข้อมูลดีเอ็นเอแต่ละบล็อกมีเอกลักษณ์แบบสุ่มและไม่แตก",
		lookintroduce: "คลิกเพื่อดูรายละเอียดของ Baidu สารานุกรมกัญชาค่า。",
		what: "โซ่บล็อกอะไร",
		Block_chain: "บล็อกโซ่เป็นหลักที่ใช้ร่วมกันฐานข้อมูลที่จัดเก็บข้อมูลหรือข้อมูล มันมีคุณลักษณะบางอย่างที่ไม่สามารถปลอมแปลงได้ทั้งหลักสูตรทิ้งเครื่องหมายสามารถติดตามความโปร่งใสเปิดและการบำรุงรักษาร่วมกัน",
		wallet: "กระเป๋าสตางค์ส่วนกลาง ไปที่ศูนย์กลางของกระเป๋าสตางค์ ทำไมกระเป๋าสตางค์ส่วนกลางไม่สามารถสอบถามเกี่ยวกับการโอนเงิน",
		example: "ตัวอย่างเช่นที่อยู่กระเป๋าสตางค์ของคุณเองเป็นคุณให้ที่อยู่ของคุณเป็น 10usdt แต่คุณใช้ธุรกรรมกัญชาเพื่อสอบถามข้อมูลเท่านั้นที่สามารถสอบถามผู้ให้บริการเพื่อสุ่มบัญชีที่อยู่ B หรือ C หรือ D และอื่น อีกเหตุผลหนึ่งคือว่ามันไม่ได้เป็นที่รู้จักกันว่าคุณได้ส่งต่อไปที่ USDT 10 เพราะ E เท่านั้นที่สามารถเห็นได้ว่ามันเป็นหนังสือที่อยู่ B นั่นคือเหตุผลที่กระเป๋าสตางค์ส่วนกลางไม่สามารถสอบถามข้อมูลการโอนเงินจริงในบล็อกรองเท้า",
		why_winning: "ทำไมฉันถึงชนะรางวัลต่อเนื่องหรือไม่",
		First: "มันเป็นเหตุการณ์ที่น่าจะเป็นขนาดเล็กที่ไม่ชนะหลายครั้งติดต่อกัน",
		small: "คำนิยามของเหตุการณ์ความน่าจะเป็นขนาดเล็ก",
		second: "ประการที่สองชนะและไม่ชนะเป็นเหตุการณ์แบบสุ่มและความถี่ของเหตุการณ์สุ่มมีแนวโน้มที่จะมีเสถียรภาพ ในสถานการณ์ที่ไม่ซ้ำความน่าจะเป็นของสิ่งที่เกิดขึ้นเท่ากับทุกคนในกรณีนี้ทุกคนเป็นธรรม ในเวลาเดียวกันเหตุการณ์สุ่มจะปฏิบัติตามกฎของตัวเลขขนาดใหญ่ที่ความถี่ของเหตุการณ์สุ่มจะคล้ายกับที่ของกฎหมายของความน่าจะเป็นและในกรณีของการเพิ่มขึ้นอย่างต่อเนื่องของความถี่ของการถ่ายโอนความน่าจะเป็นของการชนะรางวัลและความล้มเหลวมีแนวโน้มที่จะคงที่ ดังนั้นโปรดดำเนินการโอนเงินของคุณด้วยการเพิ่มความถี่ของการโอนความน่าจะเป็นทั้งหมดของการชนะจะเพิ่มขึ้น",
		whydelay: "ทำไมมันถึงถูกเลื่อนออกไป",
		Click_to_view: "คลิกเพื่อดูสถานะของบล็อกโซ่： 《คุณค่าของความไว้วางใจช้าที่จะได้รับมัน》",
		six: "ทำไมสกุลเงินมีตัวเลือกชนิดของคีย์เพื่อให้ USDT ฉันควรเลือกอันไหน",
		global: " มีโซ่สาธารณะที่รู้จักกันดีมากทั่วโลก",
		click_look: "คลิกที่ลิงค์เพื่อดูรายละเอียด",
		how: "วิธีการเกี่ยวกับชนิดของสกุลเงินที่มีที่อยู่หรือเลือกผิด คุณจะกลับไป",
		For_instance: " ตัวอย่างเช่นคุณควรเลือกประเภท trc20 USD เมื่อคุณโอนเงินแต่คุณเลือกประเภทอื่นๆของสหรัฐอเมริกาหรือสหรัฐอเมริกาและคุณจะสูญเสียเงิน",
		How_to_force: "คลิกเพื่อดูสิ่งที่เกิดขึ้นถ้าคุณโอนเงินผิด？",
		Other_problems: "ปัญหาอื่นๆ",
		callwe: "หากมีคําถามใดๆโปรดติดต่อเรา",
		immediately: "เดิมพันทันที",
		company: "ข้อมูลบริษัท",
		link: "เชื่อมโยงมิตรภาพ",
		register: "ลงทะเบียนเหรียญดิจิตอลไปศูนย์กระเป๋าสตางค์",
		Already_have: "ข้ามขั้นตอนนี้ถ้าคุณมีกระเป๋าสตางค์",
		download: "ดาวน์โหลดและลงทะเบียนเหรียญดิจิตอลไปยังศูนย์กระเป๋าสตางค์",
		com_title: "กระเป๋าสตางค์เหรียญดิจิตอลที่เกี่ยวข้องกับเว็บไซต์กวดวิชาดังนี้"
	},
	register: { //登录注册
		login_tips: "กรุณาตั้งค่ารหัสผ่านเข้าสู่ระบบของคุณ",
		address: "กรุณาใส่ที่อยู่กระเป๋าสตางค์",
		confirm: "ยืนยันรหัสผ่าน",
		confirmupdate: "ยืนยันการเปลี่ยนแปลง",
		toRegister: "ไปลงทะเบียน",
		agreement: "เข้าสู่ระบบเพื่อยินยอม",
		user: "ข้อตกลงการใช้งาน",
		policy: "นโยบายความเป็นส่วนตัว",
		welcome: "ยินดีต้อนรับค่ะ",
		login: "เข้าสู่ระบบในบัญชีของคุณ",
		forget: "ลืมรหัสผ่าน",
		nowLogin: "ล็อกอิน",
		nologin: "ไม่เข้าสู่ระบบ",
		new: "สร้างบัญชีใหม่",
		login: "เป็นบัญชีผู้ใช้ของคุณ",
		account: "เลขบัญชี 8-20 หรือตัวอักษร",
		password: "รหัสผ่านมากกว่าเท่ากับหกตัวเลขตัวอักษรหรือการรวมกันของตัวอักษร",
		confirm_password: "ยืนยันรหัสผ่าน",
		inviteCode: "กรุณาใส่รหัสเชิญ",
		verificationCode: "กรุณาใส่รหัสการตรวจสอบ",
		toRegister: "ลงทะเบียน",
		noaccount: "ไม่มีบัญชี",
		toLogin: "เข้าสู่ระบบ"
	},
	address: {
		warmprompt: "กรุณากรอกที่อยู่กระเป๋าเงินที่ถูกต้องมิฉะนั้นคุณไม่สามารถถอนเงินได้ทันทีที่คุณกรอกที่อยู่กระเป๋าเงินไม่สามารถแก้ไขได้กรุณาติดต่อฝ่ายบริการลูกค",
		tips: "กรุณาผูกอย่างน้อยหนึ่งที่อยู่กระเป๋าสตางค์และไม่สามารถเรียกคืนได้เมื่อคุณลืมรหัสผ่านของคุณ",
		TRC20: "เพื่อหลีกเลี่ยงข้อผิดพลาดในการป้อนข้อมูลกรุณาคัดลอกและวางลงที่นี่（TRC20）",
		toBind: "ผูกพันทันที",
		noBind: "ไม่ผูกพัน",
	},
	luckyhash: { //幸运哈希
		walletName: 'กระเป๋าสตางค์',
		exchange: "คราว",
		reward: "รางวัล",
		Customerservice: "เว็บบอร์ด",
		instructions: "อธิบาย",
		luckyhash: "กัญชาโชคดี",
		entertainment: "กัญชาเมืองบันเทิง",
		Doublesided: "สองหน้า",
		odds: "ต่อรอง",
		immediately: "เดิมพันทันที",
		combination: "กลุ่มก้อน",
		LongHuge: "มังกรและเสือรวมกัน",
		baccarat: "ทุกครอบครัว",
		gallbladder: "ความกล้าหาญ",
		Hashracingcar: "กัญชาแข่ง",
		Hashspeedboat: "เรือกอนโดลากัญชา",
		Hashracing: "กัญชาแข่งม้า",
		bothsides: "สองหน้า",
		problem: "คำถามที่พบบ่อย",
		all: "ดูเพิ่มเติม",
		friend: "หุ้นส่วน"
	},
	history: {
		block: "บล็อค",
		type: "รูปร่างลักษณะ",
		big: "ใหญ่โต",
		highly: "ความสูงของบล็อก",
		results_of: "ผลลัพธ์"
	},
	entertainment: {
		lastBlock: "บล็อกล่าสุด",
		resultValue: "ผลรางวัล",
		currentblock: "ปัจจุบันบล็อก",
		nextBlock: "บล็อกรางวัลเปิด",
		toLotteryRecord: "ประวัติรางวัล",
		block: "บล็อค",
		money1: "ผลรวม",
		type: "รูปร่างลักษณะ",
		all: "ดูเพิ่มเติม",
		both_sides: "สองหน้า",
		big: "ใหญ่โต",
		small: "กะเปี๊ยก",
		single: "แผ่วเบา",
		double: "คู่",
		champion: "ชนะเลิศ",
		yajun: 'ลำดับที่สอง',
		champion_one_size: "รหัสแชมป์เดี่ยว",
		crown: "มงกุฎและ",
		andbig: "ใหญ่",
		andsmall: "เล็ก",
		andsingle: "โสด",
		anddouble: "คู่",
		championtwo: "แชมป์ทั้งสองด้าน",
		combination: "กลุ่มก้อน",
		forlarge: "ใบปลิวโฆษณา",
		smallsingle: "ใบปลิวโฆษณา",
		large_double: "คู่ใหญ่",
		small_double: "คู่เล็ก",
		Long_Huge: "มังกรและเสือรวมกัน",
		dragon: "มังกร",
		tiger: "กล้าหาญ",
		us: "ปิดกล้อง",
		baccarat: "ทุกครอบครัว",
		zhuang: "ตรัง",
		idle: "เวลาว่าง",
		gallbladder: "ความกล้าหาญ",
		Atotalof: "คอมมอน",
		note: "ธนบัตร",
		Check_the_details: "ดูรายละเอียด",
		money: "ดุลกระเป๋าสตางค์",
		pause: "การเลือก",
		reset: "ตั้งค่าใหม่",
		inputmoney: "โปรดระบุจำนวนเงิน",
		submit: "ทูลเกล้าฯถวาย",
		password: "กรุณาใส่รหัสผ่าน",
		betting: "การพนัน",
		determine: "ยืนยัน",
	},
	details: {
		block: "บล็อค",
		money: "ผลรวม",
		type: "รูปร่างลักษณะ",
		resultValue: "ผลรางวัล",
		all: "ดูเพิ่มเติม",
		address: "ที่อยู่เดิมพัน",
		toLotteryRecord: "ประวัติรางวัล",
		money: "กระเป๋าสตางค์เดิมพัน",
		copy: "คัดลอกที่อยู่เดิมพัน",
		ts: "อย่าใช้ที่อยู่แลกเปลี่ยนหรือคุณจะไม่ได้รับรางวัลกลับ",
		USDT: "กรุณาโอนเงินไป USDT TRX ฟิลด์（Trc20）",
		Betting_amount: "วางเดิมพัน",
		inputmoney: "โปรดระบุจำนวนเงินเดิมพัน",
		confirm: "ยืนยัน",
		cancel: "ยกเลิก",
	},
	data: {
		noData: 'ไม่มีข้อมูล',
		deleteSuc: 'ลบสำเร็จ',
		iscon: 'ยืนยันการเดิมพัน',
		fenpan: 'ไม่มีการเดิมพันจะได้รับอนุญาตในการปิดถาด',
		erweima: 'บันทึกรหัส 2D'
	},
	announcement: {
		title: 'ประกาศล่าสุด',
		close: 'ปิด',
	},
	phone: {
		title: 'ผูกหมายเลขโทรศัพท์มือถือ',
		phone: 'หมายเลขโทรศัพท์มือถือ',
		input: 'กรุณาป้อนหมายเลขโทรศัพท์มือถือที่ถูกผูกไว้',
		code: 'รหัสการตรวจสอบ',
		inputcode: "กรุณาใส่รหัสการตรวจสอบ",
		getCode: 'ได้รับรหัสการตรวจสอบ',
		details: 'กรุณากรอกรหัสพื้นที่และหมายเลขโทรศัพท์มือถือก่อน',
		success: 'ตรวจสอบรหัสส่งเรียบร้อยแล้ว',
		bsuccess: 'ผูกพันสำเร็จ',
		jiaoyi: 'กรุณาตั้งค่ารหัสผ่านก่อน',
		caozuo: "การผ่าตัดสำเร็จ",
		touxiang: "กรุณาเลือก Avatar",
		buzu: 'ขาดสมดุล',
		tuiguan: 'ศูนย์ส่งเสริมการขาย',
		qubie: 'คลิกเพื่อดูความแตกต่างของห่วงโซ่กระเป๋าสตางค์',
		yhm: 'กรุณาใส่ชื่อผู้ใช้ของคุณ',
		mm: 'กรุณาใส่รหัสผ่านของคุณ',
		xqgg: 'ไปเดินเล่นก่อน',
		llwm: 'ติดต่อเรา',
		lj: 'กรุณาเชื่อมต่อกระเป๋าสตางค์ของคุณก่อน',
		dk: 'Открыть в бумажнике APP',
		qd: 'เราหวังว่าจะเข้าร่วมของคุณ',
		yjmx: 'รายละเอียดคณะกรรมการ'
	},
	vip: {
		jl: "รางวัล",
		xrjl: 'รางวัลใหม่',
		ckgz: 'ดูกฎ',
		zcsj: 'การลงทะเบียน',
		qbsj: 'ผูกโทรศัพท์มือถือและที่อยู่กระเป๋าสตางค์',
		dlq: 'ต้องการ',
		qwc: 'ทำให้เสร็จ',
		ylq: 'ได้รับ',
		tgrw: 'งานส่งเสริมการขาย',
		rwjl: 'รางวัลงาน',
		yq: 'เชื้อเชิญ',
		ghy: 'เป็นเพื่อนที่ดี',
		lqcg: 'ได้รับ',
		bz: "Please enter the recharge currency",
		je: 'Please enter the recharge amount',
		xyb: 'next step',
		czpz: 'Please upload the recharge voucher',
		zzhx: 'Please enter transfer hash',
		ljtj: 'Submit now'

	}

}
export default lang



// WEBPACK FOOTER //
// ./src/i18n/language/Thai.js